import PropTypes from 'prop-types';

const $Type = {
  // {key: value} of type {any: unknown}
};

const singleType = {
  _: PropTypes.string,
  '#name': PropTypes.string,
  $: PropTypes.shape($Type),
};

const ArrayOfSingleType = PropTypes.arrayOf(PropTypes.shape(singleType));

singleType.$$ = ArrayOfSingleType;

const XocsType = {
  ...singleType,
  $$: ArrayOfSingleType,
};

export default PropTypes.shape(XocsType);
